import { styled } from "@mui/material/styles";
import type Message from "messaging/message";

const Mark = styled("span")(({ theme }) => ({
  ...theme.typography.caption,
  color: theme.palette.text.secondary,
  fontStyle: "italic",
  marginInline: theme.spacing(0.5),
}));

/**
 * Says that a message was edited, beside when it was sent, as a proposal comment's caption says
 * "Edited". The History control beside it opens the earlier text. A deleted or retracted message is
 * not marked: what it said is gone, and the History control names that instead.
 */
export default function EditedMark(props: Readonly<{ message: Message }>) {
  const { message } = props;
  if (!message.updated || message.isDeleted || message.retracted) return null;
  return <Mark data-testid="message-edited-mark">Edited</Mark>;
}
